module.exports = __webpack_public_path__ + "static/media/level-3.4ae81827.glb";